import { Link } from "react-router-dom"
import LogoTitle from "../../assets/images/logo-s.png"
import "./index.scss"
import AnimatedLetters from "../AnimatedLetters"
import { useEffect, useState } from "react"
import Logo from "./Logo"
import Loader from "react-loaders"

const Home = () => {
  const [letterClass, setLetterClass] = useState("text-animate")

  const greetingArray = ["o", "n", "j", "o", "u", "r", ",", " "]

  const welcomeArray = [
    "W",
    "e",
    "l",
    "c",
    "o",
    "m",
    "e",
    " ",
    "t",
    "o",
    " ",
    "s",
    "d",
    "l",
    "e",
    "y",
  ]

  const nameArray = [
    "o",
    "u",
    "l",
    "e",
    "y",
    "m",
    "a",
    "n",
    "e",
    " ",
    "D",
    "i",
    "a",
    "l",
    "l",
    "o",
  ]

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover")
    }, 4000)
  }, [])

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>B</span>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={greetingArray}
              index={0}
            />
            <br />

            <AnimatedLetters
              letterClass={letterClass}
              strArray={welcomeArray}
              index={15}
            />
            <br />

            <img src={LogoTitle} alt="S" />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              index={greetingArray.length} // pour éviter les doublons de classes
            />
            <br />
          </h1>

          <h2>
            Ingénieur Logiciel / Développeur Fullstack <br />
            Software Engineer / Fullstack Developer <br />
            Spring Boot, Spring WebFlux, React, Next.js & Angular
          </h2>
          <p>
            Ingénieur en systèmes d'information et données, je conçois et
            développe des applications web performantes avec Java, Spring Boot
            et Spring WebFlux côté backend, ainsi que React, Next.js et Angular
            côté frontend. Mon travail s'appuie sur une architecture robuste,
            des données bien gouvernées et une intégration fluide entre
            frontend, backend et data.
          </p>

          <div className="cta-group">
            <Link to="/about" className="flat-button flat-button-secondary">
              EN SAVOIR PLUS
            </Link>
            <Link to="/contact" className="flat-button">
              ME CONTACTER
            </Link>
          </div>
        </div>
        <Logo />
      </div>
      <Loader type="pacman"></Loader>
    </>
  )
}

export default Home
